import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_nav_link = _resolveComponent("ion-nav-link")!

  return (_openBlock(), _createBlock(_component_ion_row, {
    class: "container ion-align-items-center ion-justify-content-center",
    style: {"margin-top":"-1px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, {
        size: "6",
        "size-md": "3",
        class: "ion-align-items-center ion-text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_img, {
            alt: "Donatos Rewards Logo",
            src: require('@/assets/donatos-rewards-logo-light.svg'),
            style: {"max-width":"250px","margin":"auto"}
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_col, {
        size: "6",
        "size-md": "3",
        class: "ion-align-items-center ion-text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-justify-content-center pb-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                class: _normalizeClass(["interstate-bold join-now-btn", 'join-now-btn' + _ctx.orientation]),
                mode: "md",
                color: "light",
                size: _ctx.buttonSize,
                fill: "outline",
                onClick: _cache[0] || (_cache[0] = () => _ctx.router.replace('/signup'))
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Join Now ")
                ])),
                _: 1
              }, 8, ["class", "size"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, {
            class: _normalizeClass(["ion-justify-content-center", 'sign-in-cta' + _ctx.orientation])
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Already a Member? ", -1)),
              _createVNode(_component_ion_nav_link, {
                class: "sign-in-btn",
                onClick: _cache[1] || (_cache[1] = () => _ctx.router.replace('/login'))
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Sign in ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}